"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCoordinates = void 0;
/**
 * Formats latitude and longitude coordinates with N/S/E/W indicators
 * @param latitude - Latitude value (positive = North, negative = South)
 * @param longitude - Longitude value (positive = East, negative = West)
 * @param precision - Number of decimal places (default: 4)
 * @returns Formatted string like "40.7128°N 74.0060°W"
 */
const formatCoordinates = function (latitude, longitude) {
  let precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;
  if (latitude == null || longitude == null) {
    return '-';
  }
  const latDirection = latitude >= 0 ? 'N' : 'S';
  const lngDirection = longitude >= 0 ? 'E' : 'W';
  const latValue = Math.abs(latitude).toFixed(precision);
  const lngValue = Math.abs(longitude).toFixed(precision);
  return "".concat(latValue, "\xB0").concat(latDirection, " ").concat(lngValue, "\xB0").concat(lngDirection);
};
exports.formatCoordinates = formatCoordinates;
//# sourceMappingURL=format-coordinates.js.map